/* Thème neutre 4.0 : filtres à facettes de collection.
   - Mise à jour SANS rechargement par la Section Rendering API (?section_id=...), adresse partageable
     (pushState / popstate), requêtes concurrentes annulées, repli sur une navigation normale en cas d'erreur.
   - Ordinateur : panneau latéral. Téléphone : tiroir (Échap, voile, piège du focus, retour du focus).
   - Plage de prix à deux curseurs accessibles (clavier) liés à deux champs numériques.
   - Sans JavaScript la page reste un formulaire GET complet : ce script ne fait qu'améliorer.
   Écouteurs délégués sur document : posés une seule fois, compatibles avec le changement de page d'InstantClick. */
(function () {
  'use strict';

  var MQ = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
  var state = { ctrl: null, seq: 0, opener: null, timer: null };

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function getRoot() { return qs('[data-nt-fx]'); }
  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if ((el.matches || el.msMatchesSelector).call(el, sel)) return el;
      el = el.parentNode;
    }
    return null;
  }
  function isDrawer() { return !!(MQ && MQ.matches); }
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  /* ---------- initialisation d'une racine ---------- */
  function init() {
    var root = getRoot();
    if (!root) return;
    root.setAttribute('data-nt-ready', '');
    qsa('[data-nt-fx-price]', root).forEach(syncPriceFromFields);
    if (!root.__ntFxSeen) {
      root.__ntFxSeen = true;
      history.replaceState(Object.assign({}, history.state || {}, { ntFx: true }), '', location.href);
    }
  }

  /* ---------- plage de prix ---------- */
  function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) ? n : null; }

  function paintPrice(box) {
    var lo = qs('[data-nt-fx-rlo]', box), hi = qs('[data-nt-fx-rhi]', box);
    var min = +box.getAttribute('data-min'), max = +box.getAttribute('data-max');
    var span = (max - min) || 1;
    box.style.setProperty('--lo', Math.max(0, Math.min(1, (+lo.value - min) / span)));
    box.style.setProperty('--hi', Math.max(0, Math.min(1, (+hi.value - min) / span)));
    /* le curseur du bas passe au-dessus quand les deux sont collés à droite */
    lo.style.zIndex = (+lo.value >= max - span * 0.05) ? 5 : '';
  }

  function syncPriceFromFields(box) {
    var min = +box.getAttribute('data-min'), max = +box.getAttribute('data-max');
    var nlo = qs('[data-nt-fx-nlo]', box), nhi = qs('[data-nt-fx-nhi]', box);
    var lo = qs('[data-nt-fx-rlo]', box), hi = qs('[data-nt-fx-rhi]', box);
    var a = num(nlo.value), b = num(nhi.value);
    lo.value = a === null ? min : Math.max(min, Math.min(max, Math.floor(a)));
    hi.value = b === null ? max : Math.max(min, Math.min(max, Math.ceil(b)));
    paintPrice(box);
  }

  /* curseur déplacé : les champs suivent ; une borne atteinte laisse le champ vide (pas de filtre) */
  function syncFieldsFromRanges(box, which) {
    var min = +box.getAttribute('data-min'), max = +box.getAttribute('data-max');
    var nlo = qs('[data-nt-fx-nlo]', box), nhi = qs('[data-nt-fx-nhi]', box);
    var lo = qs('[data-nt-fx-rlo]', box), hi = qs('[data-nt-fx-rhi]', box);
    if (+lo.value > +hi.value) {
      if (which === 'lo') lo.value = hi.value; else hi.value = lo.value;
    }
    nlo.value = (+lo.value <= min) ? '' : lo.value;
    nhi.value = (+hi.value >= max) ? '' : hi.value;
    paintPrice(box);
  }

  /* champ numérique validé : bornes, ordre, curseurs */
  function normalizeFields(box) {
    var min = +box.getAttribute('data-min'), max = +box.getAttribute('data-max');
    var nlo = qs('[data-nt-fx-nlo]', box), nhi = qs('[data-nt-fx-nhi]', box);
    var a = num(nlo.value), b = num(nhi.value);
    if (a !== null) a = Math.max(min, Math.min(max, a));
    if (b !== null) b = Math.max(min, Math.min(max, b));
    if (a !== null && b !== null && a > b) { var t = a; a = b; b = t; }
    nlo.value = (a === null || a <= min) ? '' : String(a);
    nhi.value = (b === null || b >= max) ? '' : String(b);
    syncPriceFromFields(box);
  }

  /* ---------- adresse ---------- */
  function currentBase() { return location.pathname; }

  function urlFromForm(root) {
    var form = qs('[data-nt-fx-form]', root);
    var p = new URLSearchParams();
    /* paramètres étrangers aux filtres conservés (view, utm...) */
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') !== 0 && k !== 'sort_by' && k !== 'page' && k !== 'section_id') p.append(k, v);
    });
    var data = new FormData(form);
    data.forEach(function (v, k) {
      if (k === 'sort_by') return;
      v = String(v).trim();
      if (v !== '') p.append(k, v);
    });
    var sort = qs('[data-nt-fx-sort]', root);
    if (sort && sort.value && sort.value !== sort.getAttribute('data-default')) p.set('sort_by', sort.value);
    var q = p.toString();
    return currentBase() + (q ? '?' + q : '');
  }

  /* ---------- requête + échange du contenu ---------- */
  function go(url, opts) {
    opts = opts || {};
    var root = getRoot();
    if (!root || !window.fetch || !window.URLSearchParams || !window.DOMParser) { location.href = url; return; }
    var results = qs('[data-nt-fx-results]', root);
    var id = root.getAttribute('data-section-id');
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', id);
    if (state.ctrl) state.ctrl.abort();
    var ctrl = window.AbortController ? new AbortController() : null;
    state.ctrl = ctrl;
    var seq = ++state.seq;
    results.setAttribute('aria-busy', 'true');
    fetch(u.pathname + u.search, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        if (seq !== state.seq) return;
        swap(root, html);
        if (opts.push !== false) history.pushState({ ntFx: true }, '', url);
        results.setAttribute('aria-busy', 'false');
        afterSwap(root, opts);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (seq !== state.seq) return;
        location.href = url;
      });
  }

  function swap(root, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nr = doc.querySelector('[data-nt-fx]');
    if (!nr) throw new Error('section sans filtres');
    var focusId = document.activeElement && document.activeElement.id;
    var open = {};
    qsa('[data-nt-fx-group]', root).forEach(function (d) { open[d.getAttribute('data-nt-fx-group')] = d.open; });
    var expanded = {};
    qsa('[data-nt-fx-group]', root).forEach(function (d) {
      var b = qs('.nt-fx__gbody', d);
      if (b && b.classList.contains('is-expanded')) expanded[d.getAttribute('data-nt-fx-group')] = true;
    });

    /* résultats */
    qs('[data-nt-fx-results]', root).innerHTML = qs('[data-nt-fx-results]', nr).innerHTML;
    /* nombre, puces */
    qs('[data-nt-fx-count]', root).innerHTML = qs('[data-nt-fx-count]', nr).innerHTML;
    var chips = qs('[data-nt-fx-chips]', root), nchips = qs('[data-nt-fx-chips]', nr);
    chips.innerHTML = nchips.innerHTML;
    if (nchips.hasAttribute('hidden')) chips.setAttribute('hidden', ''); else chips.removeAttribute('hidden');
    /* bouton Filtres */
    var badge = qs('[data-nt-fx-badge]', root), nbadge = qs('[data-nt-fx-badge]', nr);
    badge.textContent = nbadge.textContent;
    if (nbadge.hasAttribute('hidden')) badge.setAttribute('hidden', ''); else badge.removeAttribute('hidden');
    /* tri */
    var sort = qs('[data-nt-fx-sort]', root), nsort = qs('[data-nt-fx-sort]', nr);
    if (sort && nsort) sort.value = nsort.value;
    /* panneau : groupes et pied, états d'ouverture conservés */
    qs('[data-nt-fx-groups]', root).innerHTML = qs('[data-nt-fx-groups]', nr).innerHTML;
    qsa('[data-nt-fx-group]', root).forEach(function (d) {
      var k = d.getAttribute('data-nt-fx-group');
      if (open.hasOwnProperty(k)) d.open = open[k];
      var b = qs('.nt-fx__gbody', d);
      if (b && expanded[k]) {
        b.classList.add('is-expanded');
        var m = qs('[data-nt-fx-more]', d);
        if (m) { m.textContent = m.getAttribute('data-less'); m.setAttribute('aria-expanded', 'true'); }
      }
    });
    qs('[data-nt-fx-apply-label]', root).innerHTML = qs('[data-nt-fx-apply-label]', nr).innerHTML;
    var ca = qs('.nt-fx__clearall', root), nca = qs('.nt-fx__clearall', nr);
    if (ca && nca) { ca.setAttribute('href', nca.getAttribute('href')); if (nca.hasAttribute('hidden')) ca.setAttribute('hidden', ''); else ca.removeAttribute('hidden'); }
    qsa('[data-nt-fx-price]', root).forEach(syncPriceFromFields);
    if (focusId) {
      var again = document.getElementById(focusId);
      if (again && root.contains(again)) { try { again.focus({ preventScroll: true }); } catch (e) { again.focus(); } }
    }
  }

  function afterSwap(root, opts) {
    /* modules du socle à relancer sur les nouvelles cartes (comme après « Voir plus ») */
    try {
      if (window.Shopify && Shopify.theme_settings) {
        if (Shopify.theme_settings.show_multiple_currencies && typeof convertCurrencies === 'function') convertCurrencies();
        if (typeof productPage !== 'undefined' && productPage.init) productPage.init();
        if (Shopify.theme_settings.quick_shop_enabled && typeof quickShop !== 'undefined' && quickShop.init) quickShop.init();
        if (typeof hideNoScript === 'function') hideNoScript();
        if (Shopify.theme_settings.pagination_type === 'infinite_scroll' && typeof enableInfiniteScroll === 'function') enableInfiniteScroll();
      }
      if (window.lazySizes && lazySizes.autoSizer) lazySizes.autoSizer.checkElems();
    } catch (e) { /* un module du socle absent ne doit jamais bloquer le filtrage */ }
    document.dispatchEvent(new CustomEvent('nt:facets:updated', { detail: { url: location.href } }));
    if (opts.scroll !== false) scrollToResults(root);
    if (opts.focusCount) { var c = qs('[data-nt-fx-count]', root); if (c) { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } } }
  }

  function scrollToResults(root) {
    var top = qs('.nt-fx__top', root);
    if (!top) return;
    var r = top.getBoundingClientRect();
    var hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bv-hdr-h'), 10) || 0;
    if (r.top < 0 || r.top > window.innerHeight * 0.6) {
      window.scrollTo({ top: Math.max(0, window.pageYOffset + r.top - hdr - 12), behavior: reduced() ? 'auto' : 'smooth' });
    }
  }

  function applyForm(root, opts) { go(urlFromForm(root), opts || {}); }

  /* ---------- tiroir ---------- */
  function focusables(el) {
    return qsa('a[href],button:not([disabled]),input:not([disabled]),select,summary,[tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return !n.hidden && n.offsetParent !== null || n === document.activeElement; });
  }

  function openDrawer(root, opener) {
    if (root.classList.contains('is-open')) return;
    var panel = qs('[data-nt-fx-panel]', root);
    state.opener = opener || null;
    root.classList.add('is-open');
    root.querySelector('[data-nt-fx-overlay]').hidden = false;
    document.body.classList.add('nt-fx-lock');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Filtres de la collection');
    var o = qs('[data-nt-fx-open]', root);
    if (o) o.setAttribute('aria-expanded', 'true');
    /* le panneau devient visible au prochain rendu : le focus part ensuite sur « Fermer » */
    window.setTimeout(function () { var c = qs('[data-nt-fx-close]', panel); if (c) c.focus(); }, 30);
  }

  function closeDrawer(root, noFocus) {
    if (!root || !root.classList.contains('is-open')) return;
    var panel = qs('[data-nt-fx-panel]', root);
    root.classList.remove('is-open');
    root.querySelector('[data-nt-fx-overlay]').hidden = true;
    document.body.classList.remove('nt-fx-lock');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    var o = qs('[data-nt-fx-open]', root);
    if (o) o.setAttribute('aria-expanded', 'false');
    if (!noFocus && state.opener && document.contains(state.opener)) { try { state.opener.focus(); } catch (e) { /* rien */ } }
    state.opener = null;
  }

  /* ---------- écouteurs délégués ---------- */
  function bind() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var root = getRoot();
      if (!root) return;

      var openBtn = closest(t, '[data-nt-fx-open]');
      if (openBtn) { e.preventDefault(); openDrawer(root, openBtn); return; }
      if (closest(t, '[data-nt-fx-close]') || closest(t, '[data-nt-fx-overlay]')) { e.preventDefault(); closeDrawer(root); return; }

      var more = closest(t, '[data-nt-fx-more]');
      if (more) {
        e.preventDefault();
        var body = closest(more, '.nt-fx__gbody');
        var on = body.classList.toggle('is-expanded');
        more.textContent = more.getAttribute(on ? 'data-less' : 'data-more');
        more.setAttribute('aria-expanded', on ? 'true' : 'false');
        return;
      }

      /* « Voir N produits » : le filtrage est déjà fait, on ferme le tiroir */
      if (closest(t, '[data-nt-fx-apply]') && root.hasAttribute('data-nt-ready')) {
        e.preventDefault();
        if (isDrawer()) closeDrawer(root, true);
        else applyForm(root);
        return;
      }

      var link = closest(t, 'a[data-nt-fx-link]') || closest(t, '.nt-fx__results .paginate a[href]');
      if (link && root.contains(link) && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
        e.preventDefault();
        e.stopPropagation();
        var inResults = !!closest(link, '.nt-fx__results');
        go(link.getAttribute('href'), { focusCount: !inResults, scroll: true });
      }
    }, true);

    document.addEventListener('change', function (e) {
      var t = e.target;
      var root = getRoot();
      if (!root || !root.hasAttribute('data-nt-ready')) return;
      if (closest(t, '[data-nt-fx-sort]')) { applyForm(root, { scroll: false }); return; }
      if (!closest(t, '[data-nt-fx-form]')) return;
      var box = closest(t, '[data-nt-fx-price]');
      if (box) {
        if (t.matches('[data-nt-fx-rlo],[data-nt-fx-rhi]')) syncFieldsFromRanges(box, t.matches('[data-nt-fx-rlo]') ? 'lo' : 'hi');
        else normalizeFields(box);
      }
      clearTimeout(state.timer);
      state.timer = setTimeout(function () { applyForm(root, { scroll: !isDrawer() }); }, 220);
    });

    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-nt-fx-rlo],[data-nt-fx-rhi]')) return;
      var box = closest(t, '[data-nt-fx-price]');
      if (box) syncFieldsFromRanges(box, t.matches('[data-nt-fx-rlo]') ? 'lo' : 'hi');
    });

    document.addEventListener('submit', function (e) {
      var form = closest(e.target, '[data-nt-fx-form]');
      var root = getRoot();
      if (!form || !root || !root.hasAttribute('data-nt-ready')) return;
      e.preventDefault();
      var box = qs('[data-nt-fx-price]', form);
      if (box) normalizeFields(box);
      clearTimeout(state.timer);
      applyForm(root);
      if (isDrawer()) closeDrawer(root, true);
    });

    document.addEventListener('keydown', function (e) {
      var root = getRoot();
      if (!root || !root.classList.contains('is-open')) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeDrawer(root); return; }
      if (e.key === 'Tab') {
        var f = focusables(qs('[data-nt-fx-panel]', root));
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        var panel = qs('[data-nt-fx-panel]', root);
        if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    window.addEventListener('popstate', function (e) {
      var root = getRoot();
      if (!root || !e.state || !e.state.ntFx) return;
      go(location.pathname + location.search, { push: false, scroll: false });
    });

    if (MQ) {
      var onMq = function () { var r = getRoot(); if (r && !isDrawer()) closeDrawer(r, true); };
      if (MQ.addEventListener) MQ.addEventListener('change', onMq); else if (MQ.addListener) MQ.addListener(onMq);
    }
    if (window.InstantClick && InstantClick.on) InstantClick.on('change', init);
  }

  if (!window.__ntFxBound) { window.__ntFxBound = true; bind(); }
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
})();
